import React from "react";
import { Link } from "react-router-dom";

const LandingPage = () => {
  return (
    <div className="bg-gradient-to-b from-white to-purple-50">
      {/* Hero Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-10 pb-24">
        <div className="lg:flex lg:items-center lg:justify-between">
          <div className="lg:w-1/2">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold">
              <span className="block">Tag. Brag.</span>
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-600 mt-1">
                Bomb it.
              </span>
            </h1>
            <p className="mt-6 text-lg md:text-xl text-gray-600 max-w-3xl">
              Drop your best pics, tag the crew, and relive the chaos together — without hunting through 47 group chats.
            </p>
            <div className="mt-10 flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
              <Link
                to="/signup"
                className="px-8 py-3 text-center text-white font-medium bg-gradient-to-r from-purple-600 to-pink-600 rounded-full text-base md:text-lg shadow-md hover:shadow-lg transform transition hover:-translate-y-0.5"
              >
                Drop a Bomb 💣
              </Link>
              <Link
                to="/login"
                className="px-8 py-3 text-center text-gray-700 font-medium bg-white border border-gray-300 rounded-full text-base md:text-lg shadow-sm hover:shadow-md hover:bg-gray-50"
              >
                View the Feed 👀
              </Link>
            </div>
          </div>
          
          {/* Hero Image Section with Animated Blobs and Photo Stack */}
          <div className="hidden lg:block lg:w-1/2 mt-10 lg:mt-0">
            <div className="relative">
              <div className="absolute -top-6 -left-6 w-72 h-72 bg-purple-200 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob"></div>
              <div className="absolute -bottom-6 -right-6 w-72 h-72 bg-pink-200 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob animation-delay-2000"></div>
              <div className="absolute inset-0 w-72 h-72 bg-blue-200 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob animation-delay-4000 left-20"></div>

              <div className="absolute shadow-2xl rounded-2xl overflow-hidden transform rotate-2 bg-white p-2">
                <div className="w-52 h-40 bg-gradient-to-br from-purple-400 to-pink-400 rounded-lg flex items-center justify-center">
                  <span className="text-white font-bold text-sm">📸 Party Vibes</span>
                </div>
              </div>
              <div className="absolute -bottom-4 left-52 shadow-2xl rounded-2xl overflow-hidden transform -rotate-3 bg-white p-2">
                <div className="w-52 h-40 bg-gradient-to-br from-pink-400 to-purple-400 rounded-lg flex items-center justify-center">
                  <span className="text-white font-bold text-sm">🎉 Tagged Squad</span>
                </div>
              </div>
              <div className="absolute top-20 right-8 shadow-2xl rounded-2xl overflow-hidden transform rotate-6 bg-white p-2">
                <div className="w-52 h-40 bg-gradient-to-br from-purple-500 to-pink-500 rounded-lg flex items-center justify-center">
                  <span className="text-white font-bold text-sm">💀 Chaos Mode</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* How It Works Section */}
      <div className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-3xl font-extrabold text-gray-900">
              How to Blow It Up
            </h2>
            <p className="mt-4 text-gray-600">Three steps to photo chaos</p>
          </div>

          <div className="mt-16">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-purple-50 rounded-xl p-6 border border-purple-100 hover:shadow-lg transition-all">
                <div className="w-12 h-12 rounded-full bg-gradient-to-r from-purple-600 to-pink-600 flex items-center justify-center mb-4">
                  <span className="text-white text-xl">📱</span>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">
                  1. Drop Photos
                </h3>
                <p className="text-gray-600">
                  Add your party, event, or random hangout pics. No filter needed — authenticity hits different.
                </p>
              </div>

              <div className="bg-pink-50 rounded-xl p-6 border border-pink-100 hover:shadow-lg transition-all">
                <div className="w-12 h-12 rounded-full bg-gradient-to-r from-pink-600 to-purple-600 flex items-center justify-center mb-4">
                  <span className="text-white text-xl">🏷️</span>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">
                  2. Tag the Crew
                </h3>
                <p className="text-gray-600">
                  Tag your friends and they get notified instantly. New to the app? They'll get an invite to join the chaos.
                </p>
              </div>

              <div className="bg-purple-50 rounded-xl p-6 border border-purple-100 hover:shadow-lg transition-all">
                <div className="w-12 h-12 rounded-full bg-gradient-to-r from-purple-600 to-pink-600 flex items-center justify-center mb-4">
                  <span className="text-white text-xl">💥</span>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">
                  3. Blow It Up
                </h3>
                <p className="text-gray-600">
                  Photos go live on the shared feed. Download, react, or just lurk — we don't judge.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Testimonials */}
      <div className="py-16 bg-gradient-to-r from-purple-50 to-pink-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-3xl font-extrabold text-gray-900">
              What the Squad Says
            </h2>
            <p className="mt-4 text-gray-600">Real talk from real users</p>
          </div>

          <div className="mt-12 space-y-8 md:space-y-0 md:grid md:grid-cols-3 md:gap-x-8 md:gap-y-10">
            {/* Testimonial 1 */}
            <div className="bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition-all">
              <div className="flex items-center mb-4">
                <div className="h-10 w-10 rounded-full bg-gradient-to-r from-purple-400 to-pink-400 flex items-center justify-center">
                  <span className="text-white font-bold">A</span>
                </div>
                <div className="ml-3">
                  <h3 className="text-lg font-bold text-gray-900">Aaliyah</h3>
                </div>
              </div>
              <p className="text-gray-600 italic">
                "Way better than the group chat. Finally, all my pics are in one place instead of scattered across 15 different threads."
              </p>
            </div>

            {/* Testimonial 2 */}
            <div className="bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition-all">
              <div className="flex items-center mb-4">
                <div className="h-10 w-10 rounded-full bg-gradient-to-r from-pink-400 to-purple-400 flex items-center justify-center">
                  <span className="text-white font-bold">M</span>
                </div>
                <div className="ml-3">
                  <h3 className="text-lg font-bold text-gray-900">Marcus</h3>
                </div>
              </div>
              <p className="text-gray-600 italic">
                "I don't even ask for pics anymore, they're just there. It's like having a personal paparazzi squad."
              </p>
            </div>

            {/* Testimonial 3 */}
            <div className="bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition-all">
              <div className="flex items-center mb-4">
                <div className="h-10 w-10 rounded-full bg-gradient-to-r from-purple-500 to-pink-500 flex items-center justify-center">
                  <span className="text-white font-bold">J</span>
                </div>
                <div className="ml-3">
                  <h3 className="text-lg font-bold text-gray-900">Jen</h3>
                </div>
              </div>
              <p className="text-gray-600 italic">
                "My mom found my rave pics… and even she liked them 💀. This app is dangerous but I love it."
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* CTA */}
      <div className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-r from-purple-600 to-pink-600 rounded-3xl shadow-xl overflow-hidden">
            <div className="px-6 py-12 sm:px-12 lg:px-16">
              <div className="text-center">
                <h2 className="text-3xl font-extrabold text-white sm:text-4xl">
                  Stop lurking. Start tagging.
                </h2>
                <p className="mt-4 text-lg leading-6 text-purple-100">
                  Join the chaos. Your squad is waiting.
                </p>
                <div className="mt-8">
                  <Link
                    to="/signup"
                    className="px-8 py-3 font-bold rounded-full text-purple-700 bg-white hover:bg-purple-50 text-base md:text-lg shadow-sm transition-all hover:scale-105"
                  >
                    Let's Go 🚀
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-gray-900">
        <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex-shrink-0 flex items-center">
              <span className="font-bold text-xl bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
                Photo Bomb
              </span>
            </div>
            <div className="mt-4 md:mt-0 text-center md:text-right">
              <p className="text-gray-400 text-sm mb-1">
                Built with chaos. Shared with love.
              </p>
              <p className="text-gray-500 text-xs">
                &copy; {new Date().getFullYear()} Photo Bomb. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
